import * as Yup from 'yup'

export const PersonalDataValidationSchema = Yup.object().shape({
  name: Yup.string().required('Se requiere el nombre'),
  surname: Yup.string().required('Se requiere los apellidos'),
  nationality: Yup.string().required('Se requiere la Nacionalidad'),
  birthcity: Yup.string().required('Se requiere la Ciudad de Nacimiento'),
  birthdate: Yup.date().required('Se requiere la Fecha de Nacimiento'),
  documentType: Yup.string().required('Se requiere el Tipo de Documento'),
  document: Yup.string().required('Se requiere el Número del documento'),
  maritalStatus: Yup.string().required('Se requiere el Estado civil'),
  gender: Yup.string().required('Se requiere el Sexo'),
  bloodType: Yup.string().required('Se requiere el Tipo sangüineo'),
  children: Yup.number()
    .transform((value) => (Number.isNaN(value) ? undefined : value))
    .when('maritalStatus', {
      is: (maritalStatus: string) => ['Casado', 'Concubinato'].includes(maritalStatus),
      then: (value) =>
        value.required('Se requiere el Número de hijos').min(0, 'El Número de hijos debe ser un número válido'),
    }),
  partnerName: Yup.string().when('maritalStatus', {
    is: (maritalStatus: string) => ['Casado', 'Concubinato'].includes(maritalStatus),
    then: (value) => value.required('Se requiere el CONYUGUE - Nombres y Apellidos'),
  }),
  address: Yup.object().shape({
    street: Yup.string().required('Se requiere la Dirección - Avenida o Calle'),
    neighborhood: Yup.string().required('Se requiere el Barrio'),
    city: Yup.string().required('Se requiere la Ciudad donde reside'),
    state: Yup.string().required('Se requiere el Departamento'),
  }),
  email: Yup.string().required('Se requiere el E-mail').email('Se requiere un E-mail valido'),
  mobile: Yup.string().required('Se requiere el Número del celular'),
  phone: Yup.string(),
  experience: Yup.string().required('Se requiere informar se tienes experiencia formal de trabajo'),
  instagram: Yup.string(),
  facebook: Yup.string(),
  linkedin: Yup.string(),
  pinterest: Yup.string(),
  xsocial: Yup.string(),
  posees: Yup.array().of(Yup.string()),
})
